import React, { useCallback, useMemo, useState } from "react";
import { NAV_LINKS } from "@/lib/site";
import { scrollToId, scrollToIdWhenUnlocked } from "@/lib/scroll";
import { useActiveSection, useScrolledPast } from "@/hooks/useLandingNav";
import { BrandBar, HeaderLogo } from "@/components/landing/HeaderBrand";
import { DesktopNav } from "@/components/landing/DesktopNav";
import { MobileNav } from "@/components/landing/MobileNav";

export const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const scrolled = useScrolledPast(12);
  const sectionIds = useMemo(() => NAV_LINKS.map((link) => link.id), []);
  const active = useActiveSection(sectionIds);

  const handleDesktopSelect = useCallback((id) => scrollToId(id), []);

  const handleMobileSelect = useCallback((id) => {
    setMenuOpen(false);
    scrollToIdWhenUnlocked(id);
  }, []);

  return (
    <header
      data-testid="site-header"
      className={`sticky top-0 z-50 bg-white backdrop-blur ${
        scrolled ? "shadow-[var(--shadow-sm)]" : ""
      }`}
    >
      <BrandBar order="navy" />

      <div className="mx-auto flex h-28 w-full max-w-6xl items-center justify-between gap-4 px-4 sm:h-32 sm:px-6 lg:h-[9.5rem] lg:px-8">
        <HeaderLogo />

        <DesktopNav active={active} onSelect={handleDesktopSelect} />

        <div className="flex items-center gap-2">
          <MobileNav
            open={menuOpen}
            onOpenChange={setMenuOpen}
            onSelect={handleMobileSelect}
          />
        </div>
      </div>
    </header>
  );
};
